import { configureProxyOptions } from "./proxy";
import { default as nodeFetch } from "node-fetch";
export function fetch(url, options) {
    options = configureProxyOptions(options);
    return nodeFetch(url, options);
}
//# sourceMappingURL=fetch.js.map